import { createAction } from 'redux-actions';

export const INTL_LANGUAGE_SET = 'INTL_LANGUAGE_SET';
export const INTL_TIMEZONE_SET = 'INTL_TIMEZONE_SET';

export const setLanguage = createAction('INTL_LANGUAGE_SET');
export const setTimeZone = createAction('INTL_TIMEZONE_SET');
